export const pickUpDropArr = [
    {"value":"Zabeel Business Centre (Smark 9) - Umm Hurair Road - Dubai - United Arab Emirates"},

]